var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tag-select-search',{attrs:{"selectedTags":_vm.draft.tags,"unselectedTags":_vm.unselectedTags,"supportsMatchType":_vm.supportsMatchType,"matchType":_vm.draft.matchType},on:{"change":_vm.onTagChange,"matchTypeChange":_vm.onMatchTypeChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }